/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Insert_Event_BelowInputs */

const en_shortcut_keys_desc_insert_event_below = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Event_BelowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert new event below the selected event`)
};

const fr_shortcut_keys_desc_insert_event_below = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Event_BelowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserer un nouvel evenement sous l'evenement selectionne`)
};

const de_shortcut_keys_desc_insert_event_below = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Event_BelowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fügen Sie unterhalb des ausgewählten Ereignisses ein neues Ereignis ein.`)
};

const it_shortcut_keys_desc_insert_event_below = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Event_BelowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci un nuovo evento sotto l'evento selezionato`)
};

const ru_shortcut_keys_desc_insert_event_below = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Event_BelowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставьте новое событие ниже выбранного события.`)
};

const es_shortcut_keys_desc_insert_event_below = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Event_BelowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar nuevo evento debajo del evento seleccionado`)
};

const zh_cn2_shortcut_keys_desc_insert_event_below = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Event_BelowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在选定事件下方插入新事件`)
};

const ja_shortcut_keys_desc_insert_event_below = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Event_BelowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したイベントの下に新しいイベントを挿入します`)
};

const hi_shortcut_keys_desc_insert_event_below = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Event_BelowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित इवेंट के नीचे नया इवेंट डालें`)
};

const pt_pt2_shortcut_keys_desc_insert_event_below = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Event_BelowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insira um novo evento abaixo do evento selecionado.`)
};

/**
* | output |
* | --- |
* | "Insert new event below the selected event" |
*
* @param {Shortcut_Keys_Desc_Insert_Event_BelowInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_insert_event_below = /** @type {((inputs?: Shortcut_Keys_Desc_Insert_Event_BelowInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Insert_Event_BelowInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_insert_event_below(inputs)
	if (locale === "de") return de_shortcut_keys_desc_insert_event_below(inputs)
	if (locale === "it") return it_shortcut_keys_desc_insert_event_below(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_insert_event_below(inputs)
	if (locale === "es") return es_shortcut_keys_desc_insert_event_below(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_insert_event_below(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_insert_event_below(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_insert_event_below(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_insert_event_below(inputs)
	return en_shortcut_keys_desc_insert_event_below(inputs)
});